import { render, staticRenderFns } from "./registrationForm.vue?vue&type=template&id=29abfd0e&"
import script from "./registrationForm.vue?vue&type=script&lang=js&"
export * from "./registrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports